import { useParams, useNavigate, useLocation, useSearchParams } from "react-router-dom";
import React, { Component } from "react";

// Enhanced withRouter with all React Router v6 features
export const withRouter = (WrappedComponent) => {
  return function WithRouterWrapper(props) {
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();

    const router = {
      params,
      navigate,
      location,
      searchParams: Object.fromEntries(searchParams),
      setSearchParams
    };

    return <WrappedComponent {...props} router={router} />;
  };
};